import { render, staticRenderFns } from "./DesignLogo.vue?vue&type=template&id=5c85049e"
import script from "./DesignLogo.vue?vue&type=script&lang=ts"
export * from "./DesignLogo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports